import React, { useEffect, useState } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useNavigate } from "react-router-dom";

function Generatepickupschedulecustomer()
{
    const navigate = useNavigate();
    const [customerlist, setCustomerlist] = useState([]);
    const [userdata, setUserdata] = useState({});
    const {headers1,headers2,logout}=AuthUser();
    const [selectedcustomer, setSelectedcustomer] = useState('');
    const [customerid, setCustomerid] = useState('');
    const [consignments, setConsignments] = useState(''); 
    const [totalweight, setTotalweight] = useState('');
    const [destination, setDestination] = useState(''); 
    const [product_Type, setProduct_Type] = useState('Document'); // Default to Document
    const [pickupDate, setPickupDate] = useState(getTodayDateString());
    const [pickupAddressList, setPickupAddressList] = useState([]); // List of pickup addresses
    const [pickupAddressSelected, setPickupAddressSelected] = useState('');
    const [warehouselist, setWarehouselist] = useState([]);
     const [currentTime, setCurrentTime] = useState(new Date());
    const formattedTime = currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(()=>{
        Getcustomerlist();
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserdata(items);
        }
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 10000);
        return () => clearInterval(timerId);
    },[]);
    
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    const handleTimeChange = (e) => {
        const [hours, minutes] = e.target.value.split(':');
        const newTime = new Date(currentTime);
        newTime.setHours(hours, minutes);
        setCurrentTime(newTime);
    };
    
     const Getcustomerlist=()=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'Customerlist',
                headers:headers1,
                
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setCustomerlist(response.data.value);
                }
                else
                {
                    setCustomerlist([]);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }

         const Getwarehousebycustomerid=(id)=>{
            axios({
                method: 'post',
                url: Global.baseUrl+'AdminWarehouseList',
                headers:headers1,
                data: {
                    cust_id: id
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    setWarehouselist(response.data.value);
                }
                else
                {
                    setWarehouselist([]);
                }
            })
            .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
        }

        const filterBy = (option, state)=> {
        if (state.selected.length) {
          return true;
        }
        return option.label.toLowerCase().indexOf(state.text.toLowerCase()) > -1;
      }

      const handelcustomerid=(e)=>{
        const id = e[0].value;
        const name = e[0].label;
        setSelectedcustomer(name)
        setCustomerid(id);
        Getwarehousebycustomerid(id);
    }

    const submit = () => {
    // Create a validation object for better error tracking
    const validationErrors = [];
    
    // Customer validation
    if (!customerid || !selectedcustomer) {
        validationErrors.push("Please select a customer");
    }
    
    // Consignments validation
    if (!consignments) {
        validationErrors.push("Please enter consignment numbers");
    } else if (isNaN(consignments) || consignments <= 0) {
        validationErrors.push("Please enter a valid consignment number (greater than 0)");
    } else if (consignments > 100) {
        validationErrors.push("Maximum 100 consignments allowed at once");
    }
    
    // Weight validation
    if (!totalweight) {
        validationErrors.push("Please enter total expected weight");
    } else if (isNaN(totalweight) || totalweight <= 0) {
        validationErrors.push("Please enter a valid weight (greater than 0)");
    }
    
    // Destination validation
    if (!destination) {
        validationErrors.push("Please enter destination details");
    } else if (destination.trim().length < 5) {
        validationErrors.push("Destination address must be at least 5 characters");
    }
    
    // Pickup address validation
    if (!pickupAddressSelected) {
        validationErrors.push("Please select a pickup address");
    }
    
    // Date validation
    if (!pickupDate) {
        validationErrors.push("Please select a pickup date");
    } else {
        // Check if pickup date is in the past
        const selectedDate = new Date(pickupDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate < today) {
            validationErrors.push("Pickup date cannot be in the past");
        }
    }
    
    // Time validation
    if (!formattedTime) {
        validationErrors.push("Please select a pickup time");
    }
    
    // Product type validation (if required)
    if (!product_Type) {
        validationErrors.push("Please select product type");
    }
    
    // Show all validation errors at once
    if (validationErrors.length > 0) {
        validationErrors.forEach(error => {
            toast.error(error);
        });
        return;
    }
    
    // Show loading toast
    const loadingToast = toast.loading("Generating pickup run sheet...");
    
    // Disable submit button to prevent double submission
    setIsSubmitting(true); // You'll need to add this state
    
    axios({
        method: 'post',
        url: Global.baseUrl + 'GeneratePickupRunSheet',
        headers: headers2,
        data: {
            customerid: customerid,
            consignments: parseInt(consignments), // Send as integer
            totalweight: parseFloat(totalweight), // Send as float
            destination: destination.trim(),
            product_Type: product_Type,
            pickupDate: pickupDate,
            pickupTime: formattedTime,
            warehouseid: pickupAddressSelected
        },
        timeout: 30000 // 30 second timeout
    })
    .then(function (response) {
        toast.dismiss(loadingToast);
        
        if (response.data.status === 200) {
            toast.success(response.data.message, {
                duration: 1000,
                onClose: () => {
                    navigate('/ScheduledPickupList', { 
                        state: { refresh: true } 
                    });
                }
            });
        } else if (response.data.status === 404) {
            toast.error(response.data.message || "Resource not found");
        } else if (response.data.status === 422) {
            // Handle validation errors from backend
            if (response.data.errors) {
                Object.values(response.data.errors).forEach(error => {
                    toast.error(error[0]);
                });
            } else {
                toast.error(response.data.message || "Validation failed");
            }
        } else if (response.data.status === 500) {
            toast.error(response.data.message || "Server error occurred");
        } else {
            toast.error("Unexpected response from server");
        }
    })
    .catch(function (error) {
        toast.dismiss(loadingToast);
        
        if (error.code === 'ECONNABORTED') {
            toast.error("Request timeout. Please try again.");
        } else if (error.response) {
            // Server responded with error status
            if (error.response.status === 401) {
                toast.error("Session expired. Please login again.");
                logout();
                navigate('/', { replace: true });
            } else if (error.response.status === 403) {
                toast.error("You don't have permission to perform this action");
            } else if (error.response.status === 404) {
                toast.error("API endpoint not found");
            } else if (error.response.status === 422) {
                // Handle validation errors
                const errors = error.response.data.errors;
                if (errors) {
                    Object.keys(errors).forEach(field => {
                        toast.error(`${field}: ${errors[field][0]}`);
                    });
                } else {
                    toast.error("Validation failed");
                }
            } else if (error.response.status >= 500) {
                toast.error("Server error. Please try again later.");
            } else {
                toast.error(error.response.data.message || "An error occurred");
            }
        } else if (error.request) {
            // Request made but no response
            toast.error("No response from server. Check your internet connection.");
        } else {
            // Something else happened
            toast.error("An unexpected error occurred");
        }
        
        console.error("Submission error:", error);
    })
    .finally(function () {
        setIsSubmitting(false); // Re-enable submit button
    });
};

    return(
        <>
        <LeftPanel/>
            <main className='home-section'>
            <Header/>
            <ToastContainer/>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Pick Run Sheet</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Schedule New Customer PRS</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                </div>
            </div>
            <div className="row justify-content-between">
                <div className="col-12 col-md-6">
                    <div className="card mb-3">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-md-12 mb-3">
                                    <div><label htmlFor="email" className="form-label">Select Customer: <span className="text-danger">*</span></label></div>
                                    <Typeahead
                                        filterBy={filterBy}
                                        id="toggle-example1"
                                        options={customerlist}
                                        placeholder="Choose a customer..."
                                        onChange={handelcustomerid}
                                    />
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <div><label htmlFor="email" className="form-label">No. of Consignments: <span className="text-danger">*</span></label></div>
                                    <input type="text" className="form-control" id="text" placeholder="Enter consignment numbers" onChange={(e)=>setConsignments(e.target.value)} />
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <div><label htmlFor="email" className="form-label">Total Weight: <span className="text-danger">*</span></label></div>
                                    <input type="text" className="form-control" id="text" placeholder="Enter total expected" onChange={(e)=>setTotalweight(e.target.value)} />
                                </div>
                                <div className="col-12 col-md-12 mb-3">
                                    <div><label htmlFor="email" className="form-label">Destination Description: <span className="text-danger">*</span></label></div>
                                    <input type="text" className="form-control" id="text" placeholder="Enter location details" onChange={(e)=>setDestination(e.target.value)} />
                                </div>
                                <div className="col-12 col-md-12 mb-3">
                                    <div><label htmlFor="email" className="form-label">Item Type: <span className="text-danger">*</span></label></div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" id="Parcel" checked={product_Type == 'Parcel'} onChange={()=>setProduct_Type('Parcel')}/>
                                        <label className="form-check-label" htmlFor="inlineRadio1">Parcel</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" id="Document" checked={product_Type == 'Document'} onChange={()=>setProduct_Type('Document')}/>
                                        <label className="form-check-label" htmlFor="inlineRadio2">Document</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <div><label htmlFor="email" className="form-label">Date for Pickup: <span className="text-danger">*</span></label></div>
                                    <input type="date" className="form-control" placeholder="Date" value={pickupDate} onChange={(e)=>setPickupDate(e.target.value)} />
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <div><label htmlFor="email" className="form-label">Time for Pickup: <span className="text-danger">*</span></label></div>
                                    <input type="time" className="form-control" placeholder="Time" value={formattedTime} onChange={handleTimeChange} />
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <div className="d-flex justify-content-between">
                                        <div ><label htmlFor="email" className="form-label">Pickup Address: <span className="text-danger">*</span></label></div>
                                    </div>
                                    <select className="form-select" onChange={(e)=>setPickupAddressSelected(e.target.value)} value={pickupAddressSelected}>
                                    <option value="">-- Please Select --</option>
                                    {warehouselist.map((item, index) => (
                                        <option key={index} value={item.unique_id}>{item.warehouseName}</option>
                                    ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="">
                <button className={`btn btn-primary${isSubmitting ? 'disabled' : ''}`} onClick={submit} disabled={isSubmitting}> {isSubmitting ? 'Generating...' : 'Generate Pickup Run Sheet'}</button>
            </div>
            <Footer/>
            </main>
        </>
    );
}
export default Generatepickupschedulecustomer;